import { defineMessages } from 'react-intl'

export default defineMessages({
  enterCustomCode: {
    id: 'components.enter.custom.code',
    defaultMessage: `Enter custom code...`,
  },
  unlabeledImageText: {
    id: 'components.unlabeled.image',
    defaultMessage: `Unlabeled image`,
  },
  postTitleImage: {
    id: 'components.post.title.image',
    defaultMessage: `Title image`,
  },
  embeddedContent: {
    id: 'components.embedded.content',
    defaultMessage: `Embedded content`,
  },
  noDataText: {
    id: 'components.no.data.text',
    defaultMessage: `No rows found`,
  },
})
